import React from "react";
import "./CalculatorResult.css";

export default function CalculatorResult({ title, onCompute, result }) {
  const handleComputing = () => {
    onCompute()
  }
  return (
    <>
      <div className="calculatorBtnWrapper centeredFlex">
        <button className="calculateBtn" onClick={handleComputing}>محاسبه</button>
      </div>
      <div className="calculatorResultContainer centeredFlex">
        <p className="calculatorResult">{result}</p>
        <p className="calculatorTitle">{title}</p>
      </div>
    </>
  );
}
